'use strict';

module.exports = {
    CREATED: 'schedule.created',
    PAUSED: 'schedule.paused',
    RESUMED: 'schedule.resumed'
};